import { supabase } from '../../integrations/supabase/client';

export interface Bem {
  id: number;
  tenant_id: number;
  codigo_bem: number;
  preco_bem: number;
  parcela_ate_contemplacao: number;
  parcela_incorporado: number;
  antecipacao_taxa_adm_valor: number;
  primeira_parcela_ate_contemplacao: number;
  primeira_parcela_incorporado: number;
  grupo_id: number;
  tipo_bem: string;
  created_at: string;
  updated_at: string;
}

export class SupabaseBemService {
  async findAll(): Promise<Bem[]> {
    try {
      const { data, error } = await supabase
        .from('bens')
        .select('*')
        .order('codigo_bem', { ascending: true });

      if (error) {
        console.error('Erro ao buscar bens:', error);
        throw error;
      }

      return data || [];
    } catch (error) {
      console.error('Erro no SupabaseBemService.findAll:', error);
      throw error;
    }
  }

  async findById(id: number): Promise<Bem | null> {
    try {
      const { data, error } = await supabase
        .from('bens')
        .select('*')
        .eq('id', id)
        .single();

      if (error) {
        console.error('Erro ao buscar bem por ID:', error);
        return null;
      }

      return data;
    } catch (error) {
      console.error('Erro no SupabaseBemService.findById:', error);
      return null;
    }
  }

  async findByGrupoId(grupoId: number): Promise<Bem[]> {
    try {
      const { data, error } = await supabase
        .from('bens')
        .select('*')
        .eq('grupo_id', grupoId)
        .order('codigo_bem', { ascending: true });

      if (error) {
        console.error('Erro ao buscar bens por grupo:', error);
        throw error;
      }

      return data || [];
    } catch (error) {
      console.error('Erro no SupabaseBemService.findByGrupoId:', error);
      throw error;
    }
  }

  async create(bem: Omit<Bem, 'id' | 'created_at' | 'updated_at'>): Promise<Bem> {
    try {
      const { data, error } = await supabase
        .from('bens')
        .insert([bem])
        .select()
        .single();

      if (error) {
        console.error('Erro ao criar bem:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Erro no SupabaseBemService.create:', error);
      throw error;
    }
  }

  async update(id: number, bem: Partial<Omit<Bem, 'id' | 'created_at' | 'updated_at'>>): Promise<Bem> {
    try {
      const { data, error } = await supabase
        .from('bens')
        .update(bem)
        .eq('id', id)
        .select()
        .single();

      if (error) {
        console.error('Erro ao atualizar bem:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Erro no SupabaseBemService.update:', error);
      throw error;
    }
  }

  async delete(id: number): Promise<boolean> {
    try {
      const { error } = await supabase
        .from('bens')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Erro ao deletar bem:', error);
        throw error;
      }

      return true;
    } catch (error) {
      console.error('Erro no SupabaseBemService.delete:', error);
      throw error;
    }
  }
}

export const bensSupabaseService = new SupabaseBemService();
